module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "partBody"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "c01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterTitle"
  })]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterOpenerText"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Around the year 1760, a ship of Scotch immigrants came to be wrecked on the shores of this place. Although the vessel was lost, her passengers and crew managed to find shelter here. They struggled through the winter—many taking ill, the women losing their children, the men making the difficult journey down North Mountain to the valley below, carrying sacks of potatoes and other goods back to their temporary home, now called Scots Bay.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("In the spring, when all who had been stranded chose to make their way to more established communities, the daughter of the ship’s captain, Annie MacIssac, stayed behind. She had fallen in love with a Mi’kmaq man she called Silent Rare.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("On the evening of a full moon in June, Silent went out in his canoe to catch the shad that were spawning around the tip of Cape Split. As the night wore on, Annie began to worry that some ill had befallen her love. She looked across the water for signs of him but found nothing. She walked to the cove where they had first met and began to call out to him, promising her heart, her fidelity and a thousand sons to his name. The moon, seeing Annie’s sadness, began to sing, forcing the waves inland, strong and fast, bringing Silent safely back to his lover.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Since that time, every child born from the Rare name has been male, and even now, when the moon is full, you can hear her voice, the voice of the moon, singing the sailors home.")])]), _vm._v(" "), _c('p', {
    staticClass: "chapterByline"
  }, [_c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("A RARE FAMILY HISTORY")]), _vm._v(", 1850")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page14"
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f9c27f84","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/c01.vue
// module id = 75
// module chunks = 0